import util from '@bmp-vue/core/api/util'
const controller = 'CentralEmailMultiplo'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  EnviarEmail: function (dto) {
    return util.Axios.Post(controller + '/EnviarEmailMultiplo', dto)
  },
  EnviarEmailByParceiro: function (dto) {
    const request = { ...dto }
    return util.Axios.Post(controller + '/EnviarEmailByParceiro', request)
  },
  EnviarEmailByParceiroBucket: function (dto) {
    const request = dto.map((mail) => { return { ...mail } })
    return util.Axios.Post(controller + '/EnviarEmailByParceiroBucket', request)
  },
  EnviarBoletosAgenda: function (dto) {
    return util.Axios.Post(controller + '/EnviarBoletosAgenda', dto)
  },
  EnviarBoletosAgenda: function (dto) {
    return util.Axios.Post(controller + '/EnviarBoletosAgenda', dto)
  },
})
